
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface DisplayNavigationProps {
  goToPrevPage: () => void;
  goToNextPage: () => void;
  isHebrew: boolean;
  isMobile?: boolean;
}

const DisplayNavigation: React.FC<DisplayNavigationProps> = ({ 
  goToPrevPage, 
  goToNextPage, 
  isHebrew,
  isMobile = false
}) => {
  return (
    <div className={`
      flex gap-2 
      ${isMobile 
        ? 'bg-black/30 backdrop-blur-md p-3 rounded-full shadow-lg border border-white/20' 
        : ''
      }
    `}>
      <Button
        onClick={goToPrevPage}
        variant={isMobile ? "secondary" : "outline"}
        size={isMobile ? "lg" : "icon"}
        className={`
          ${isMobile 
            ? "rounded-full h-14 w-14 active:scale-95 transition-transform shadow-md" 
            : ""
          }
          ${isMobile ? "bg-white/90 hover:bg-white text-synagogue-blue" : ""}
        `}
        title={isHebrew ? "לדף הבא" : "Previous page"}
        aria-label={isHebrew ? "לדף הבא" : "Previous page"}
      >
        {isHebrew ? 
          <ChevronRight className={isMobile ? "h-8 w-8" : "h-4 w-4"} /> : 
          <ChevronLeft className={isMobile ? "h-8 w-8" : "h-4 w-4"} />
        }
      </Button>

      <Button
        onClick={goToNextPage}
        variant={isMobile ? "secondary" : "outline"}
        size={isMobile ? "lg" : "icon"}
        className={`
          ${isMobile 
            ? "rounded-full h-14 w-14 active:scale-95 transition-transform shadow-md" 
            : ""
          }
          ${isMobile ? "bg-white/90 hover:bg-white text-synagogue-blue" : ""}
        `}
        title={isHebrew ? "לדף הקודם" : "Next page"}
        aria-label={isHebrew ? "לדף הקודם" : "Next page"}
      >
        {isHebrew ? 
          <ChevronLeft className={isMobile ? "h-8 w-8" : "h-4 w-4"} /> : 
          <ChevronRight className={isMobile ? "h-8 w-8" : "h-4 w-4"} />
        }
      </Button>
    </div>
  );
};

export default DisplayNavigation;
